import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getSampleById.success: {
            return action.payload;
        }

        case constants.getSampleById.error:
        case constants.getSampleById.try: {
            return initialState;
        }

        default:
            return state;
    }
}